"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RFC1918_RANGES = exports.PRIVATE_SUBNETS = exports.PRIVATE_IP_OPTIONS = void 0;
const RFC1918_RANGES = exports.RFC1918_RANGES = ['10.0.0.0/8', '172.16.0.0/12', '192.168.0.0/16'];
const PRIVATE_IP_OPTIONS = exports.PRIVATE_IP_OPTIONS = [{
  value: '0.0.0.0/8',
  label: '0.0.0.0/8',
  description: 'Default route, broadcast to the current (“this”)'
}, {
  value: '127.0.0.0/8',
  label: '127.0.0.0/8',
  description: '127.0.0.1 loopback net'
}, {
  value: '100.64.0.0/10',
  label: '100.64.0.0/10',
  description: 'CGN (Carrier Grade NAT) reserved range'
}, {
  value: '10.0.0.0/8, 172.16.0.0/12, 192.168.0.0/16',
  label: '10.0.0.0/8, 172.16.0.0/12, 192.168.0.0/16',
  description: 'RFC 1918 IPv4 Private Networks'
}, {
  value: '169.254.0.0/16',
  label: '169.254.0.0/16',
  description: 'APIPA (auto-ip address for failed DHCP requests)'
}, {
  value: '192.0.0.0/24',
  label: '192.0.0.0/24',
  description: 'IANA special purpose IPv4 space'
}, {
  value: '192.0.2.0/24',
  label: '192.0.2.0/24',
  description: 'TEST-NET for use in documentation'
}, {
  value: '198.18.0.0/15',
  label: '198.18.0.0/15',
  description: 'Private Network - reserved for testing'
}, {
  value: '198.51.100.0/24',
  label: '198.51.100.0/24',
  description: 'TEST-NET-2 for use in documentation'
}, {
  value: '203.0.113.0/24',
  label: '203.0.113.0/24',
  description: 'TEST-NET-3 for use in documentation'
}, {
  value: '224.0.0.0/4',
  label: '224.0.0.0/4',
  description: 'Reserved for Multicast'
}, {
  value: '192.88.99.0/24',
  label: '192.88.99.0/24',
  description: 'Reserved for 6to4 anycast relays'
}, {
  value: '240.0.0.0/4',
  label: '240.0.0.0/4',
  description: 'Reserved for future use'
}, {
  value: 'fc00::/7',
  label: 'fc00::/7',
  description: 'RFC 4193 IPv6 Unique Local Address (ULA)'
}, {
  value: 'fe80::/10',
  label: 'fe80::/10',
  description: 'IPv6 link-local Address'
}];
const PRIVATE_SUBNETS = exports.PRIVATE_SUBNETS = PRIVATE_IP_OPTIONS.reduce((list, opt) => {
  list.push(...opt.value.split(', '));
  return list;
}, []);